import { useEffect, useState } from "react";
import { ResponsiveContainer, AreaChart, Area, Tooltip } from "recharts";
import axiosInstance from "../../utils/axios-instance";
import UseGraph from "../../utils/use-graph";
import formQueryUrl from "../../utils/form-query-url";

type Props = {
  type: string;
};
const SimpleAreaChart = ({ type }: Props) => {
  const [data, setData] = useState({ totalCount: 0, data: [] });
  const { startDate, endDate, isRestarted } = UseGraph();

  useEffect(() => {
    const GetData = async () => {
      try {
        const filtersArray = [
          isRestarted && { restarted: true },
          startDate !== null && { startDate },
          endDate !== null && { endDate },
        ];
        const res = await axiosInstance.get(
          `/stats/chase/types/compare?filterType=${type}${formQueryUrl(
            filtersArray
          )}`
        );
        setData(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    GetData();
  }, [startDate, endDate, isRestarted, type]);

  const gradientId = `sales-area-${type.replace(/\s+/g, "-")}`;

  return (
    <div className="flex rounded-xl flex-col w-full h-full min-h-[150px] border border-edge bg-surface-muted pt-4 pb-1 px-1 hover:border-edge-strong transition-colors duration-200">
      <div className="px-3">
        <h1 className="text-light-gray font-medium text-[13px] leading-tight">
          {type}
        </h1>
        <div className="flex gap-2 items-baseline mt-1">
          <h1 className="text-[24px] font-bold text-heading-color tracking-tight tabular-nums leading-tight">
            {data?.totalCount}
          </h1>
          <p className="text-emerald-500 text-[11px] font-semibold bg-emerald-500/10 px-1.5 py-0.5 rounded-md">
            + 100.00%
          </p>
        </div>
      </div>
      <div className="flex-1 min-h-[64px] mt-2">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data?.data} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#6366F1" stopOpacity={0.28} />
                <stop offset="100%" stopColor="#6366F1" stopOpacity={0} />
              </linearGradient>
            </defs>
            <Area
              type="monotone"
              stroke="#6366F1"
              strokeWidth={2}
              dataKey="count"
              fill={`url(#${gradientId})`}
            />
            <Tooltip labelFormatter={(ID) => data?.data[ID].month} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SimpleAreaChart;
